import classNames from 'classnames';

import type { NextLinkProps } from '@shared/common/components/NextLink';
import NextLink from '@shared/common/components/NextLink';

interface ViewAppLinkProps extends Omit<NextLinkProps, 'href'> {
  href: string;
  className?: string;
}

const ViewAppLink = ({ href, className, ...props }: ViewAppLinkProps) => {
  return (
    <NextLink href={href} className={classNames('view-app-btn', className)} {...props}>
      View
    </NextLink>
  );
};

export default ViewAppLink;
